module.exports = __webpack_public_path__ + "static/gsc-logo-658d4d52b932450594020ff44daa81b0.jpg";